<template>
  <div class="jl-header-wrap">
    <div class="jl-nav-header clearfix">
      <div class="jl-nav-left">
        <router-link class="jl-logo" :to="{ name: 'home' }">
          <img src="../assets/img/logo.png" alt />
        </router-link>
      </div>
      <div class="jl-nav-right">
        <div class="js-nav-list-wrap">
          <div class="js-nav-list-box">
            <ul class="js-nav-list clearfix">
              <li v-for="item in menuData" :key="item.id">
                <router-link
                  v-if="item.name === 'home'"
                  :to="{ name: item.name }"
                  class="js-nav-home"
                >
                  <img v-if="$route.name == 'homeIndex'" src="../assets/img/home_icon_red.png" alt />
                  <img v-else src="../assets/img/home_icon.png" alt />
                </router-link>
                <router-link
                  :class="[menuActive === item.name? 'active':'']"
                  v-else
                  :to="{ name: item.name }"
                >{{item.meta.title}}</router-link>
              </li>
              <li class="alt-last">
                <a v-if="!userInfo.userId">
                  <span @click="gotolink('login')">登录</span> /
                  <span @click="gotolink('register')">注册</span>
                </a>
                <router-link
                  :class="[menuActive === 'account'? 'active':'']"
                  v-else
                  :to="{ name: 'account' }"
                >个人中心</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    const list = this.getMenu(this.$router.options.routes);
    return {
      menuData: list,
      menuActive: "" //设置导航高亮
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  watch: {
    $route(val) {
      this.setNavHight(val);
    }
  },
  created() {
    this.setNavHight();
  },
  methods: {
    setNavHight(obj) {
      let arr = this.$route.matched;
      /* let strobj = obj || this.$route;
      let pathArr = strobj.path.split("/");
      pathArr.shift();
      this.menuActive = pathArr[0]; */
      this.menuActive = arr[0].name;
    },
    getMenu(routes) {
      let list = routes || [],
        ownlist = [];
      if (list.length > 0) {
        for (let item of list) {
          if (!item.hideMenu) {
            ownlist.push(item);
          }
        }
      }
      return ownlist;
    },
    gotolink(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>


<style lang="scss" scoped>
.container-1 {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.clearfix::after {
  content: "";
  clear: both;
  display: block;
}
.jl-header-wrap {
  position: relative;
  background: #fff;
  box-shadow: 0 9px 9px rgba($color: #b8b8b8, $alpha: 0.3);
  z-index: 10;
  .jl-nav-header {
    @extend .container-1;
    height: 120px;
  }
  .jl-nav-left {
    float: left;
    height: 100%;
    .jl-logo {
      display: block;
      line-height: 120px;
      img {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  .jl-nav-right {
    float: right;
    height: 100%;
  }
  .js-nav-list-wrap {
    .js-nav-list-box {
      display: inline-block;
    }
    .js-nav-list {
      float: right;
      li {
        float: left;
        line-height: 120px;
        > a {
          position: relative;
          padding: 0 20px;
          font-size: 16px;
          color: #292929;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 1px;
            height: 100%;
            background: #e0e0e0;
          }
          &.active,
          &.router-link-exact-active {
            color: #e70819;
          }
          img {
            display: inline-block;
            vertical-align: middle;
          }
        }
        &:first-child a:before {
          width: 0;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .jl-header-wrap .js-nav-list-wrap .js-nav-list li.alt-last a span:hover,
  .jl-header-wrap .js-nav-list-wrap .js-nav-list li a:hover {
    color: #e70819;
  }
  .jl-header-wrap .js-nav-list-wrap .js-nav-list li.alt-last a:hover {
    color: #292929;
  }
}
@media screen and (max-width: 1600px) {
  .jl-header-wrap .jl-nav-header {
    height: 100px;
  }
  .jl-header-wrap .js-nav-list-wrap .js-nav-list li,
  .jl-header-wrap .jl-nav-left .jl-logo {
    line-height: 100px;
  }
}
@media screen and (max-width: 1440px) {
  .jl-header-wrap .jl-nav-header {
    height: 85px;
  }
  .jl-header-wrap .js-nav-list-wrap .js-nav-list li,
  .jl-header-wrap .jl-nav-left .jl-logo {
    line-height: 85px;
  }
}
</style>
